import Swal from 'sweetalert2'
import { toast } from 'react-toastify';
import { FormStampsLogs } from 'components/Legal/StampsLogs/FormStampsLogs';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle, parseNumber,
    FetchData,
    Helpers,

    defaultData,
    
    //------------- Forms
    Forms,
    
    globalStates

})=>{


    const openModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }
    
    const closeModal = () => {
        toggle()
    }

    const handleChangeTypeCurrency = (event) => {

        //HOOKS
        const {FormDeposit} = Forms
        const {setFormState, formState} = FormDeposit
        const {deposito_monto, deposito_tipo_cambio} = formState
        
        const { name, value } = event.target

        //Verificamos si tiene data
        const monto = deposito_monto !== '' ? deposito_monto : 0;
        const tipo_cambio = deposito_tipo_cambio !== '' ? deposito_tipo_cambio : 0;

        if (value === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value,
                deposito_quetzales : parseFloat(monto*tipo_cambio).toFixed(2),
                deposito_dolares : parseFloat(monto).toFixed(2),
            }))
        }else if (value === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value,
                deposito_quetzales : parseFloat(monto).toFixed(2),
                deposito_dolares : parseFloat(monto/tipo_cambio).toFixed(2),
            }))
        }
    }

    const handleChangeAmount = (event) => {
        const { name, value } = event.target
        
        const {FormDeposit} = Forms
        const {setFormState, formState} = FormDeposit
        const {deposito_tipo_cambio} = formState

        const valueParsed = parseNumber.setNumberMask(value)
        
        const monto = valueParsed.value !== '' ? valueParsed.value : 0;
        const tipo_cambio = deposito_tipo_cambio !== '' ? deposito_tipo_cambio : 0;
        
        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: valueParsed.value,
                [`${name}_mask`]: valueParsed.value_mask,
                deposito_quetzales : (monto*tipo_cambio),
                deposito_dolares : (monto),
            }))
        }else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: valueParsed.value,
                [`${name}_mask`]: valueParsed.value_mask,
                deposito_quetzales : (monto),
                deposito_dolares : (monto/tipo_cambio),
            }))
        }else {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: valueParsed.value,
                [`${name}_mask`]: valueParsed.value_mask
            }))
        }
    }

    const handleChangeExchangeRate = (event) => {

        //HOOKS
        const {FormDeposit} = Forms
        const {setFormState, formState} = FormDeposit
        const {deposito_monto} = formState
        
        const { name, value } = event.target

        //Verificamos si tiene data
        const monto = deposito_monto !== '' ? deposito_monto : 0;
        const tipo_cambio = value !== '' ? value : 0;

        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value,
                deposito_quetzales : (monto*tipo_cambio),
                deposito_dolares : (monto),
            }))
        }else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value,
                deposito_quetzales : (monto),
                deposito_dolares : (monto/tipo_cambio),
            }))
        }else {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value
            }))
        }
    }

    const handleClickShowModal = (_, title, compont, dataRequest, modalOpeningMode) => {
        const {setModalOpeningMode} = globalStates
        setModalOpeningMode(modalOpeningMode)
        openModal(_, title, compont, dataRequest)
    }

    const handleClickCloseModal = () => {
        
        //HOOKS
        const { FormDeposit } = Forms
        const { onResetForm } = FormDeposit
        
        onResetForm()
        closeModal()
    }

    const handleClickShowForm = (openingMode) => {
        const { setShowForm, setFormOpeningMode} = globalStates
        setFormOpeningMode(openingMode)
        setShowForm(true)
    }

    const handleClickUpdateStatusAprobacion = async () => {

        const { formOpeningMode } = globalStates

        const { FormLeases } = Forms
        const { formState } = FormLeases

        const _body = {
            aprobacion_check: 'PENDIENTE CONTRATO',
            aprobacion_usuario: user.username,
            aprobacion_observaciones: ''
        }

        // Si está en modo editable, nos saltamos cualquier insert/update
        if (formOpeningMode==='READONLY') {
            handleClickHideForm()
            return
        }

        await marvarApi.put(`/leases/common/aprobacion-check/${formState.idcontrato}`, _body)
            .then(({ data }) => {
                alertMessage(data)
                // console.log('data --------- ', data)
                if (data.title === 'OK') {
                    handleClickHideForm()
                }
            })
            .catch(error => {
                console.log('API ERROR: ', error)
            })
    }

    const handleClickHideForm = () => {

        const {setShowForm, setStepApplilication} = globalStates
        
        const {fetchAllLeaseApplications:{executeFetchAllLeaseApplications}} = FetchData
        const { FormLeases, FormFiles, FormDeposit } = Forms
        const onResetFormLeases = FormLeases.onResetForm
        const onResetFormFiles = FormFiles.onResetForm
        const onResetFormDeposit = FormDeposit.onResetForm

        onResetFormLeases()
        onResetFormFiles()
        onResetFormDeposit()
        executeFetchAllLeaseApplications()

        setStepApplilication(0)
        setShowForm(false)
    }

    const handleClickReturnStep = () => {
        const { stepApplilication, setStepApplilication} = globalStates
        setStepApplilication(stepApplilication-1)
    }

    const handleClickNextStep = () => {
        const { stepApplilication, setStepApplilication} = globalStates
        setStepApplilication(stepApplilication+1)
    }

    const handleClickFetchAllLeases = async () => {

        const { fetchAllLeaseApplications } = FetchData
        const { executeFetchAllLeaseApplications } = fetchAllLeaseApplications

        executeFetchAllLeaseApplications()

    }

    const handleClickFetchInfoLease = async (idcontrato) => {
        
        const { FormLeases} = Forms
        const { onResetForm } = FormLeases

        const { fetchInfoLease, fetchAllFiles, fetchAllDeposits, fetchAllObservations } = FetchData

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        fetchInfoLease.setParamsToSearch({idcontrato: idcontrato})
        fetchInfoLease.executeFetchInfoLease()
        
        fetchAllObservations.setParamsToSearch({idcontrato: idcontrato})
        fetchAllObservations.executeFetch()
        
        fetchAllFiles.executeFetchAllFiles()
        fetchAllDeposits.executeFetchAllDeposits()

        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowForm('READONLY')

    }

    const handleClickFetchInfoDeposit = async (iddeposit) => {
        
        const { FormDeposit } = Forms
        const { onResetForm } = FormDeposit

        const { fetchInfoDeposit } = FetchData

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        fetchInfoDeposit.setParamsToSearch({iddeposit: iddeposit})
        fetchInfoDeposit.executeFetchInfoDeposit()

        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowModal('', 'Formulario de depositos', 'ModalDeposit', {}, 'READONLY')

    }

    const handleClickPrintDepositTicket = async (iddeposit) => {

        const { fetchInfoDeposit} = FetchData
        
        fetchInfoDeposit.setParamsToSearch({
            iddeposit: iddeposit,
            printTicketFlag: true
        })
        fetchInfoDeposit.executeFetchInfoDeposit()

    }

    const handleClickEditLease = async (idcontrato) => {
        
        const { FormLeases } = Forms
        const { onResetForm } = FormLeases

        const { fetchInfoLease, fetchAllFiles, fetchAllDeposits, fetchAllObservations } = FetchData

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        fetchInfoLease.setParamsToSearch({idcontrato: idcontrato})
        fetchInfoLease.executeFetchInfoLease()

        fetchAllObservations.setParamsToSearch({idcontrato: idcontrato})
        fetchAllObservations.executeFetch()
        
        fetchAllFiles.executeFetchAllFiles()
        fetchAllDeposits.executeFetchAllDeposits()

        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowForm('EDITABLE')

    }

    const handleClickDeleteLease = (idcontrato) => {

        const { fetchAllHouses } = FetchData
        const { executeFetchAllHouses } = fetchAllHouses

        Swal.fire({
            title: '¿Desea eliminar este registro?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/leases/management/delete/${idcontrato}`)
                .then(({data}) => {
                    alertMessage(data)
                    if (data.title === 'OK') {
                        handleClickFetchAllLeases()
                        executeFetchAllHouses()
                    }
                    
                }).catch(e => {
                    console.log(e)
                    Swal.fire({
                        icon: 'error',
                        title: 'Ocurrio un problema',
                        text: 'Comuniquese con mantenimiento'
                    })
                })
            }
        })
    }

    const handleChangeHouses = (event) => {

        const { name, value } = event.target

        const { FormLeases } = Forms
        const { setFormState } = FormLeases

        const houses = JSON.parse(event.target.value || null)
        const alquilerParsed = parseNumber.setNumberMask(houses.costo_alquiler || 0)


        if(houses){
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                contrato_costo_alquiler: alquilerParsed.value,
                contrato_costo_alquiler_mask: alquilerParsed.value_mask
            }))
        }else{
            setFormState(prevState => ({
                ...prevState,
                contrato_costo_alquiler: ''
            }))
        }
    }

    const handleClickCleanUpFiles = (event) => {
        const { FormFiles } = Forms
        const { setFormState } = FormFiles

        const { fetchAllDeposits } = FetchData
        const { executeFetchAllDeposits } = fetchAllDeposits

        setFormState(prevState => ({
            ...prevState,
            fileRejections: [],
            acceptedFiles: []
        }))

        executeFetchAllDeposits()

    }

    const handleClickDeleteDocument = (iddocumento) => {

        const { fetchAllFiles } = FetchData
        const { executeFetchAllFiles } = fetchAllFiles
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/leases/common/delete-document/${iddocumento}`)
                .then( ({ data }) => {
                    alertMessage(data)
                    if (data.title === 'OK') {
                        executeFetchAllFiles()
                    }
                }).catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
    }

    const handleClickDeleteDeposit = (iddocumento) => {

        const { fetchAllDeposits } = FetchData
        const { executeFetchAllDeposits } = fetchAllDeposits
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/leases/management/delete-deposit/${iddocumento}`)
                .then( ({ data }) => {
                    alertMessage(data)
                    if (data.title === 'OK') {
                        executeFetchAllDeposits()
                        // closeModal()
                        }else{
                            
                        }
                }).catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
    }

    const handleChangeTotalMonths = (event) => {
        
        const { name, value } = event.target

        const { FormLeases } = Forms
        const { formState ,setFormState } = FormLeases

        const totalAlquiler = (formState.contrato_costo_alquiler * (value || 0))
        const totalParsed = parseNumber.setNumberMask(String(totalAlquiler) || '0')
        
        setFormState({
            ...formState,
            [ name ]: value,
            contrato_total_alquiler: totalParsed.value,
            contrato_total_alquiler_mask: totalParsed.value_mask
        });
    }

    const handleClickDownloadImage = async ( customFileName, openUrl) => {
            
        try {
            const response = await fetch(openUrl);
            const blob = await response.blob();
    
            // Crear un enlace temporal
            const enlaceTemporal = document.createElement('a');
            enlaceTemporal.href = window.URL.createObjectURL(blob);
            enlaceTemporal.download = customFileName; // Puedes cambiar el nombre del archivo
            document.body.appendChild(enlaceTemporal);
    
            // Simular clic en el enlace para iniciar la descarga
            enlaceTemporal.click();
    
            // Eliminar el enlace temporal
            document.body.removeChild(enlaceTemporal);
            
            toast.success('Se ha descargado la imagen');

        } catch (error) {
            console.error('Error al descargar la imagen', error);
        }

    }

    const onSubmitFormApplies = async (e) => {

        e.preventDefault()

        const { formOpeningMode } = globalStates
        
        const { FormLeases } = Forms
        const { formState } = FormLeases

        const { fetchAllLeaseApplications, fetchAllFiles, fetchAllObservations } = FetchData
        const { executeFetchAllLeaseApplications } = fetchAllLeaseApplications
        const { executeFetchAllFiles } = fetchAllFiles
        
        //Obtengo el idcasa del value personalizado 
        const valueHouse = JSON.parse(formState.idcasa);      
        const { idcasa } = valueHouse
        
        let _data = { 
            idcasa: idcasa,
            idcliente: formState.idcliente,
            contrato_fecha: formState.contrato_fecha,
            contrato_dia_pago: formState.contrato_dia_pago,
            contrato_plazo_meses: formState.contrato_plazo_meses,
            contrato_costo_alquiler: formState.contrato_costo_alquiler,
            contrato_total_alquiler: formState.contrato_total_alquiler,
            contrato_papeleria: formState.contrato_papeleria,
            contrato_deposito: formState.contrato_deposito,
            contrato_observaciones: formState.contrato_observaciones,
            user: user.username
        }

        // Si está en modo editable, nos saltamos cualquier insert/update
        if (formOpeningMode==='READONLY') {
            executeFetchAllFiles()
            handleClickNextStep()
            return
        }

        if(formState.idcontrato>0){
                
            _data['usuario_modifico'] = user.username; //TODO: Revisar los usuario
            _data['fecha_modifico'] = new Date();
            await marvarApi.put( `/leases/management/update/${formState.idcontrato}`, _data )
                .then(({ data }) => {

                    alertMessage(data)

                    if (data.title === 'OK') {
                        executeFetchAllFiles()
                        handleClickNextStep()
                    }
                
                }).catch(error => {console.log('API ERROR: ', error)})

        }else{

            _data['usuario_creo'] = user.username; //TODO: Revisar los usuario
            _data['fecha_creo'] = new Date();
            await marvarApi.post( `/leases/management/create`, _data )
                .then(({ data }) => {

                    alertMessage(data)

                    if (data.title === 'OK') {
                        const idcontrato = data.rows[0].insertId
                        formState.idcontrato = idcontrato
                        executeFetchAllLeaseApplications()
                        fetchAllObservations.setParamsToSearch({ idcontrato: idcontrato })
                        fetchAllObservations.executeFetch()
                        handleClickNextStep()
                    }

                }).catch(error => {console.log('API ERROR: ', error)})
        }

    }

    const onSubmitFormFiles = async (e) => {

        e.preventDefault()

        const { FormFiles, FormLeases } = Forms
        const { formState, setFormState } = FormFiles
        const formStateLeases = FormLeases.formState

        const {fetchAllFiles} = FetchData
        const {executeFetchAllFiles} = fetchAllFiles

        
        if(formState.acceptedFiles.length<=0){
            Swal.fire({
                icon: 'error',
                title: 'ERROR!!',
                text: 'Debe seleccionar al menos un documento para subir'
            })
            return
        }        

        const _data = new FormData();

        _data.append('idcontrato', formStateLeases.idcontrato);
        _data.append('department', 'GESTOR');
        _data.append('usuario_creo', user.username);
        _data.append('fecha_creo', new Date());


        formState.acceptedFiles.forEach((file, index) => {
            _data.append(`attachmentt`, file);
        });

        if(formStateLeases.idcontrato>0){
            
            await marvarApi.post( `/leases/common/create-document`, _data )
                .then(({ data }) => {

                    if (data.title === 'OK') {
                        setFormState(prevState => ({
                            ...prevState,
                            idcontrato : formStateLeases.idcontrato,
                            acceptedFiles : [],
                            fileRejections : []
                        }))
                        executeFetchAllFiles()
                    }
                    alertMessage(data)
                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
                    
        }
    }

    const onSubmitFormDeposits = async (e) => {

        e.preventDefault()

        const { FormDeposit, FormLeases } = Forms
        const { formState, onResetForm } = FormDeposit
        const formStateLeases = FormLeases.formState

        const { fetchAllDeposits, fetchInfoDeposit } = FetchData
        const { executeFetchAllDeposits } = fetchAllDeposits

        
        if(formState.movimiento_tipo==='EFECTIVO'){

            const _data = {
                idcontrato: formStateLeases.idcontrato,
                usuario_creo: user.username,
                deposito_usuario: user.username,
                fecha_creo: new Date(),
                deposito_fecha: formState.deposito_fecha,
                movimiento_tipo: formState.movimiento_tipo,
                deposito_monto: formState.deposito_monto,
                deposito_moneda: formState.deposito_moneda,
                deposito_tipo_cambio: formState.deposito_tipo_cambio,
                deposito_quetzal: formState.deposito_quetzales,
                deposito_dolares: formState.deposito_dolares,
                idcaja: formState.idcaja,
                deposito_observaciones : formState.deposito_observaciones
            }

            await marvarApi.post( `/leases/management/create-deposit-cash`, _data )
                .then(({ data }) => {
                    // console.log('response: ', data)

                    alertMessage(data)

                    if (data.title === 'OK') {
                        executeFetchAllDeposits()
                        closeModal()
                        fetchInfoDeposit.setParamsToSearch({
                            iddeposit: data.rows[0].insertId,
                            printTicketFlag: true
                        })
                        fetchInfoDeposit.executeFetchInfoDeposit()
                    }
                    
                    onResetForm()
                })
                .catch(error => {
                        console.log('API ERROR: ', error)
                })

        }

        if(formState.movimiento_tipo==='DEPOSITO'){

            if(formState.acceptedFiles.length<=0){

                const messageCustom = {
                    message: 'Debe cargar el comprobante para poder registrar el deposito',
                    title: 'FAIL',
                    rows: []
                }

                alertMessage(messageCustom)

                return
            }

            const _data = new FormData();
            
            _data.append('idcontrato', formStateLeases.idcontrato)
            _data.append('idbanco', formState.idbanco)
            _data.append('movimiento_tipo', formState.movimiento_tipo)
            _data.append('deposito_fecha', formState.deposito_fecha)
            _data.append('deposito_usuario', user.username)
            _data.append('deposito_monto', formState.deposito_monto)
            _data.append('deposito_moneda', formState.deposito_moneda)
            _data.append('deposito_tipo_cambio', formState.deposito_tipo_cambio)
            _data.append('deposito_quetzal', formState.deposito_quetzales)
            _data.append('deposito_dolares', formState.deposito_dolares)
            _data.append('boleta_numero', formState.boleta_numero)
            _data.append('usuario_creo', user.username)
            _data.append('fecha_creo', new Date(),)

            formState.acceptedFiles.forEach((file, index) => {
                _data.append(`images`, file);
            });
            
            await marvarApi.post( `/leases/management/create-deposit-bank`, _data )
            .then(({ data }) => {
                // console.log('response: ', data)
                alertMessage(data)
                
                if (data.title === 'OK') {
                    executeFetchAllDeposits()
                    closeModal()
                    fetchInfoDeposit.setParamsToSearch({
                        iddeposit: data.rows[0].insertId,
                        printTicketFlag: true
                    })
                    fetchInfoDeposit.executeFetchInfoDeposit()
                }
                
                onResetForm()
            })
            .catch(error => {
                console.log('API ERROR: ', error)
            })
        }
    }

    const onSubmitObservationsForm = async (e) => {

        e.preventDefault()

        // const { formOpeningMode } = globalStates
        
        const { ObservationsForm, FormLeases } = Forms

        const { fetchAllObservations } = FetchData

        console.log('[useActions][onSubmitObservationsForm] FormLeases.formState ::: ', FormLeases.formState)

        if (FormLeases.formState.idcontrato === '') {
            Swal.fire({
                icon: 'error',
                title: 'ERROR!!',
                text: 'No es posible guardar el comentario, no se puede identificar el contrato a asociar.'
            })
            return
        }

        if (ObservationsForm.formState.log_observacion === '') {
            Swal.fire({
                icon: 'error',
                title: 'ERROR!!',
                text: 'No a escrito nada para agregar como comentario, por favor, revise que su comentario este escrito.'
            })
            return
        }

        const _data = { 
            idcontrato: FormLeases.formState.idcontrato,
            // idcontrato: 3,
            log_departamento: 'GESTIONES',
            log_observacion: ObservationsForm.formState.log_observacion,
            idusuario: user.uid,
            user: user.username
        }

        console.log('[useActions][onSubmitObservationsForm] _data ::: ', _data)

        await marvarApi.post( `/leases/common/save-observation`, _data )
            .then(({ data }) => {

                alertMessage(data)

                fetchAllObservations.setParamsToSearch({
                    idcontrato: parseInt(FormLeases.formState.idcontrato, 10)
                    // idcontrato: parseInt(3, 10)
                })
                fetchAllObservations.executeFetch()

                ObservationsForm.onResetForm()

            }).catch(error => {console.log('API ERROR: ', error)})

    }
    
    return Object.freeze({
        handleChangeHouses,
        handleChangeTotalMonths,
        handleClickCloseModal,
        handleClickDeleteLease,
        handleClickFetchInfoLease,
        handleClickHideForm,
        handleClickNextStep,
        handleClickReturnStep,
        handleClickShowForm,
        handleClickShowModal,
        handleChangeTypeCurrency,
        handleChangeAmount,
        handleChangeExchangeRate,
        handleClickCleanUpFiles,
        handleClickDeleteDocument,
        handleClickDeleteDeposit,
        handleClickEditLease,
        handleClickFetchInfoDeposit,
        handleClickPrintDepositTicket,
        handleClickDownloadImage,
        handleClickUpdateStatusAprobacion,
        onSubmitFormApplies,
        onSubmitFormDeposits,
        onSubmitFormFiles,
        onSubmitObservationsForm
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {


    if (res) {
        const { title, message} = res
        if (title === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}